import React from 'react'
import { Alert, Grid } from '@enterprise-ui/canvas-ui-react'
import { CaseResponse } from './Queries'
import { CaseStatus } from '../Services/ConstantData'
import useInternalReopen from '../Hooks/useInternalReopen'
import {
  REOPENED_CASE_BANNER_HEADING,
  REOPENED_CASE_BANNER_MESSAGE,
  REOPEN_BANNER_WORKFLOWS,
} from './Constants'

interface MainProp {
  caseDetails: CaseResponse | undefined
}

/**
 * Banner shown on a case that is currently in `ReOpen` status, restricted to
 * the vendor compliance workflows (VCSPM / VCIAA) and only when the reopen was
 * NOT triggered internally by a Target team member.
 */
const ReopenedCaseBanner: React.FC<MainProp> = ({ caseDetails }) => {
  const { isInternalReopenKnown, isInternalReopen } =
    useInternalReopen(caseDetails)

  const isReopenStatus = caseDetails?.status === CaseStatus.REOPEN
  const isBannerWorkflow = REOPEN_BANNER_WORKFLOWS.includes(
    caseDetails?.workflow ?? '',
  )

  // While the reopen user is still unresolved we cannot tell internal from
  // external, so stay silent instead of showing a possibly wrong message.
  if (
    !isReopenStatus ||
    !isBannerWorkflow ||
    !isInternalReopenKnown ||
    isInternalReopen
  ) {
    return null
  }

  return (
    <Grid.Item xs={12}>
      <Alert type="alert" heading={REOPENED_CASE_BANNER_HEADING}>
        {REOPENED_CASE_BANNER_MESSAGE}
      </Alert>
    </Grid.Item>
  )
}

export default ReopenedCaseBanner
